module.exports = __webpack_public_path__ + "img/smart-logo.b5fc0611.png";